import { getButtonAuth } from '@/utils/buttonAuthStorage'

/**
 * 按钮权限控制 mixin（数据来自 localStorage，与登录态一致；登出会清除）
 * 支持 path 与 resourceUri 两种字段（与 v-has 指令、业务代码兼容）
 *
 * 使用方式：
 * 1. 模板：v-if="has('updateLibInfo')" 或 v-if="hasAny(['add', 'edit'])" 或 v-if="hasAll(['add', 'edit'])"
 * 2. 方法：if (this.has('delete')) { ... }
 */
export const permissionMixin = {
  methods: {
    /**
     * 获取当前用户按钮权限码列表（从 localStorage 读取，登出后自动清除）
     * 兼容 path 与 resourceUri 字段
     */
    getPermissionCodes() {
      const list = getButtonAuth()
      const codes = []
      list.forEach((item) => {
        const code = item.path || item.resourceUri
        if (code) codes.push(code)
      })
      return codes
    },

    /**
     * 是否拥有单个权限
     * @param {string} permission - 权限码，如 'updateLibInfo'
     * @returns {boolean}
     */
    has(permission) {
      if (!permission) return false
      return this.getPermissionCodes().includes(permission)
    },

    /**
     * 是否拥有给定权限中的任意一个
     * @param {string[]} permissions - 权限码数组
     * @returns {boolean}
     */
    hasAny(permissions) {
      if (!Array.isArray(permissions) || permissions.length === 0) return false
      const codes = this.getPermissionCodes()
      return permissions.some((p) => p && codes.includes(p))
    },

    /**
     * 是否拥有给定全部权限
     * @param {string[]} permissions - 权限码数组
     * @returns {boolean}
     */
    hasAll(permissions) {
      if (!Array.isArray(permissions) || permissions.length === 0) return false
      const codes = this.getPermissionCodes()
      return permissions.every((p) => p && codes.includes(p))
    }
  }
}
